export const checkIsOpen = (state) => state.modal.isOpen;
export const getModalId = (state) => state.modal.id;
